export default __webpack_public_path__ + "static/media/r.0bfe28e5.svg";